<nz-form-item>
  <nz-form-label>{{ to["title"] }}</nz-form-label>
  <nz-form-control>
    <label nz-checkbox [formControl]="formControl">
      {{ to.label }}
    </label>
  </nz-form-control>
</nz-form-item>
